<template>
    <v-layout justify-center>
        <v-responsive max-width="1080" width="100%" class="px-3 mx-n3">
            <list-heading title="자사정보 관리" />

            <v-row class="mx-n2">
                <v-col cols="12" md="" class="pa-2">
                    <v-card outlined>
                        <v-card-title>
                            <v-row>
                                <v-col cols="auto" class="py-0 subtitle-1">SEO(검색어 최적화 설정)</v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-row class="mx-n2">
                                <v-col cols="12" class="pa-2"> <v-text-field v-model="setting.seo.title" label="타이틀: Title" v-bind="attrs_input" @input="((meta('title').content = setting.seo.title) || true) && save()" /> </v-col>
                                <v-col cols="12" class="pa-2"> <v-text-field v-model="meta('title').content" label="메타태그: Title" disabled v-bind="attrs_input" @input="save" /> </v-col>
                                <v-col cols="12" class="pa-2"> <v-text-field v-model="meta('author').content" label="메타태그: Author" v-bind="attrs_input" @input="save" /> </v-col>
                                <v-col cols="12" class="pa-2"> <v-text-field v-model="meta('subject').content" label="메타태그: Subject" v-bind="attrs_input" @input="save" /> </v-col>
                                <v-col cols="12" class="pa-2"> <v-text-field v-model="meta('copyright').content" label="메타태그: Copyright" v-bind="attrs_input" @input="save" /> </v-col>
                                <v-col cols="12" class="pa-2"> <v-textarea v-model="meta('description').content" label="메타태그: Description" v-bind="attrs_input" @input="save" /> </v-col>
                                <v-col cols="12" class="pa-2"> <v-textarea v-model="meta('keywords').content" label="메타태그: Keywords" v-bind="attrs_input" @input="save" /> </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="12" md="" class="pa-2">
                    <v-card outlined>
                        <v-card-title>
                            <v-row>
                                <v-col cols="auto" class="py-0 subtitle-1">무통장입금 계좌연동</v-col>
                                <v-spacer />
                                <v-col cols="auto" class="py-0">
                                    <v-switch v-model="setting.shop.cashRecipt.enabled" v-bind="attrs_switch" @change="save"> </v-switch>
                                </v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="6"> <v-select v-model="setting.shop.accountBankCode" label="은행" :items="banks" item-text="name" item-value="code" v-bind="attrs_input" @input="save" /> </v-col>
                                <v-col cols="6"> <v-text-field v-model="setting.shop.accountHolder" label="예금주" v-bind="attrs_input" @input="save" /> </v-col>
                                <v-col cols="12"> <v-text-field v-model="setting.shop.accountNumber" label="계좌번호" v-bind="attrs_input" @input="save" /> </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <v-card outlined class="mt-4">
                        <v-card-title class="subtitle-2 font-weight-bold">
                            <v-row align="center">
                                <v-col cols="auto py-0">관리자 비밀번호 변경</v-col>
                            </v-row>
                        </v-card-title>
                        <v-card-text>
                            <v-row class="mx-n2">
                                <v-col cols="12" md="" class="pa-2"> <v-text-field v-model="admin.password" type="password" label="비밀번호" v-bind="attrs_input" /> </v-col>
                                <v-col cols="12" md="" class="pa-2"> <v-text-field v-model="admin.passwordRepeat" type="password" label="비밀번호 확인" v-bind="attrs_input" /> </v-col>
                            </v-row>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer />
                            <v-btn text color="primary" @click="saveAdmin">저장</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-col>
            </v-row>
        </v-responsive>
    </v-layout>
</template>

<script>
import api from "@/api";
import banks from "@/plugins/shop-default-banks.json";
import { attrs_input, attrs_switch } from "@/assets/variables";

import ListHeading from "@/components/console/dumb/list-heading.vue";

export default {
    components: {
        ListHeading,
    },
    data: () => ({
        setting: null,
        banks,
        admin: {
            password: "",
            passwordRepeat: "",
        },

        attrs_input,
        attrs_switch,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            try {
                await this.search();
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        async search() {
            try {
                var { setting } = await api.console.setting.getSetting();

                this.setting = setting;
            } catch (error) {
                console.error(error);
                alert(error.response ? error.response.data.message : error.message);
            }
        },

        meta(name) {
            var meta = this.setting.seo.meta.find((meta) => meta.name == name);
            if (!meta) {
                meta = { name, content: null };
                this.setting.seo.meta.push(meta);
            }
            return meta;
        },

        save() {
            api.console.setting.putSetting(this.setting);
        },

        async saveAdmin(event) {
            event.preventDefault();

            const { password, passwordRepeat } = this.admin;

            try {
                if (password !== passwordRepeat) throw new Error("비밀번호가 일치하지 않습니다.");

                await api.console.users.put({ _id: this.$store.state.payload._user, password });

                alert("비밀번호가 변경되었습니다.");
            } catch (error) {
                this.handleError(error);
            }
        },

        handleError(error) {
            console.error(error);
            if (error.response) alert(error.response.data.message);
            else alert(error.message);
        },
    },
};
</script>
